export const headers = [
  {
    text: "",
    value: "actions",
    sortable: false,
  },
  {
    text: "Transaction No.",
    value: "transactionNo",
    sortable: false,
  },
  {
    text: "Employee",
    value: "fullName",
    sortable: false,
  },
  {
    text: "Designation",
    value: "desDesc",
    sortable: false,
  },
  {
    text: "Department",
    value: "depDesc",
    sortable: false,
  },
  {
    text: "Section",
    value: "secDesc",
    sortable: false,
  },
  {
    text: "Movement Type",
    value: "movementTypeDesc",
    sortable: false,
  },
  {
    text: "Status",
    value: "status",
    sortable: false,
  },
];

export const viewHeaders = [
  //   {
  //     text: "",
  //     value: "actions",
  //     sortable: false,
  //   },
  {
    text: "Reference Sequence",
    value: "refSeq",
    sortable: false,
  },
  {
    text: "New Hire Steps",
    value: "newHireSteps",
    sortable: false,
  },
  {
    text: "Step Sequence",
    value: "stepSequence",
    sortable: false,
  },
  {
    text: "Sub Step Sequence",
    value: "subStepSequence",
    sortable: false,
  },
  {
    text: "Day Schedule",
    value: "daySched",
    sortable: false,
  },
  {
    text: "Target Activity Date",
    value: "targetDate",
    sortable: false,
  },
  {
    text: "In Charge",
    value: "inCharge",
    sortable: false,
  },
  //   {
  //     text: "When",
  //     value: "when",
  //     sortable: false,
  //   },
  {
    text: "Completed",
    value: "isCompleted",
    sortable: false,
  },
  {
    text: "Completed Date",
    value: "completedDate",
    sortable: false,
  },
  {
    text: "Remarks",
    value: "remarks",
    sortable: false,
  },
  {
    text: "Attachment",
    value: "attachmentLink",
    sortable: false,
  },
  //   {
  //     text: "Deadline Reminder",
  //     value: "reminder",
  //     sortable: false,
  //   },
];
